import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	// 관리 화면의 페이지 목록. 검색·정렬·페이지가 붙는다.
	data: [],
	// 드롭다운용 선택 목록(/clients/options). 페이지 목록과 다른 것이라 자리를 나눈다 -
	// 한 자리를 같이 쓰면 화면을 오갈 때 서로의 내용을 덮는다.
	list: [],
	loading: false,
	error: null,
	limit: 20,
	offset: 0,
	totalCount: 0,
	// 지금 본사로 지정된 고객사 { clientId, clientName }. 없으면 null. 목록은 페이지로
	// 잘려 있어 거기서 찾을 수 없으므로 서버가 따로 실어 준다(관리자에게만).
	headquarters: null,
	keyword: '',
	// 기본은 관리코드 내림차순이다. 최근 등록한 고객사를 먼저 보려고 여는 화면이다.
	sortBy: 'ID',
	sortOrder: 'DESC',
	// 방금 등록한 고객사 { clientId }. 화면이 이 값을 보고 첫 페이지로 옮긴 뒤 비운다.
	lastAdded: null,
};

export const clientSlice = createSlice({
    name: 'client',
    initialState,

    reducers: {
		setLoading: (state, action) => {
			state.loading = action.payload;
		},
        // 고객사 조회(페이징)
        fetchClientRequest: (state, action) => {
			state.loading = true;
            state.limit     = action.payload.limit;
            state.offset    = action.payload.offset;
            // 비어 있으면 비운다. 이전 값을 남기면 정렬을 푼 뒤에도 다시 받을 때 옛 정렬이 붙는다.
            state.keyword   = action.payload.keyword   ?? '';
            state.sortBy    = action.payload.sortBy    ?? null;
            state.sortOrder = action.payload.sortOrder ?? null;
        },
        fetchClientSuccess: (state,action) => {
			state.loading = false;
			state.data = action.payload.data;
			state.totalCount = action.payload.totalCount;
			state.headquarters = action.payload.headquarters ?? null;
			state.error = null;
        },
        fetchClientFailure: (state) => {
			Object.assign(state, initialState);
        },
        
        // 고객사 조회(리스트)
        fetchClientListRequest: (state, action) => {
			state.loading = true;
        },
        fetchClientListSuccess: (state,action) => {
			state.loading = false;
			state.list = action.payload.data;
			state.error = null;
        },
        fetchClientListFailure: (state) => {
			Object.assign(state, initialState);
        },

        // 고객사 등록
        fetchAddClientRequest: (state) => {
            state.loading = true;
        },
        fetchAddClientSuccess: (state, action) => {
            state.loading = false;
            state.error = null;
            state.lastAdded = { clientId: action.payload?.clientId ?? null };
        },
        clearLastAdded: (state) => {
            state.lastAdded = null;
        },
        fetchAddClientFailure: (state) => {
            Object.assign(state, initialState);
        },

        // 고객사 수정
        fetchUpdateClientRequest: (state) => {
            state.loading = true;
        },
        fetchUpdateClientSuccess: (state, action) => {
            state.loading = false;
            // 응답을 기다리지 않고 화면을 먼저 바꾼다. 필드 이름과 타입이 응답과 같아야
            // 하는데, 예전에는 대문자 키에 'Y'/'N' 문자열을 넣고 있어 아무것도 바뀌지 않았다.
            const updatedClient = action.payload;
            const index = state.data.findIndex(client => client.id === updatedClient.clientId);
            if (index !== -1) {
                state.data[index].display = updatedClient.isDisplay === 'Y';
            }
            state.error = null;
        },
        fetchUpdateClientFailure: (state) => {
            state.loading = false;
        },

        // WEBCOM-5519: Partner 메타 수정 (TB_CLIENT 의 PARTNER_TYPE/TIER/DISCOUNT_RATE/INVOICE_STATUS).
        // Primary + Secondary(TFA) 모두 성공해야 OK. 실패 시 Primary 도 rollback (백엔드에서 처리).
        fetchUpdateClientMetaRequest: (state) => {
            state.loading = true;
        },
        fetchUpdateClientMetaSuccess: (state) => {
            state.loading = false;
            state.error = null;
        },
        fetchUpdateClientMetaFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
    },
});

export const {
    setLoading,
    fetchClientRequest,
    fetchClientSuccess,
    fetchClientFailure,
    fetchClientListRequest,
    fetchClientListSuccess,
    fetchClientListFailure,
    fetchAddClientRequest,
    fetchAddClientSuccess,
    clearLastAdded,
    fetchAddClientFailure,
    fetchUpdateClientRequest,
    fetchUpdateClientSuccess,
    fetchUpdateClientFailure,
    fetchUpdateClientMetaRequest,
    fetchUpdateClientMetaSuccess,
    fetchUpdateClientMetaFailure,
} = clientSlice.actions;

export default clientSlice.reducer;